import { z } from 'zod';

const copyString = z.string().min(1);
const faqItem = z.object({ question: copyString, answer: copyString });
const todayItem = z.object({ time: copyString, title: copyString, mission: copyString });
const capabilityItem = z.object({
  id: copyString,
  label: copyString,
  description: copyString,
  offline: copyString,
  connected: copyString,
});

export const eventHomepageContentSchema = z.object({
  seo: z.object({ title: copyString, description: copyString }),
  navCta: copyString,
  hero: z.object({
    eyebrow: copyString,
    title: copyString,
    body: copyString,
    primaryCta: copyString,
    secondaryCta: copyString,
    strapline: copyString,
  }),
  offlineProof: z.object({ eyebrow: copyString, title: copyString, steps: z.array(copyString) }),
  pack: z.object({
    eyebrow: copyString,
    title: copyString,
    body: copyString,
    steps: z.array(copyString),
  }),
  today: z.object({
    eyebrow: copyString,
    title: copyString,
    missionPrefix: copyString,
    items: z.array(todayItem),
  }),
  capabilities: z.object({
    eyebrow: copyString,
    title: copyString,
    columns: z.object({ capability: copyString, offline: copyString, connected: copyString }),
    rows: z.array(capabilityItem),
  }),
  pilot: z.object({ eyebrow: copyString, title: copyString, body: copyString, status: copyString }),
  comparison: z.object({
    eyebrow: copyString,
    title: copyString,
    columns: z.object({ need: copyString, whatimean: copyString, notWhatimean: copyString }),
    rows: z.array(z.object({ need: copyString, whatimean: copyString, notWhatimean: copyString })),
  }),
  pricing: z.object({
    eyebrow: copyString,
    title: copyString,
    body: copyString,
    cards: z.array(z.object({ title: copyString, body: copyString })),
  }),
  faq: z.object({ eyebrow: copyString, title: copyString, items: z.array(faqItem) }),
  beta: z.object({
    eyebrow: copyString,
    title: copyString,
    lead: copyString,
    emailLabel: copyString,
    eventInterestLabel: copyString,
    consent: copyString,
    submit: copyString,
    sent: copyString,
    error: copyString,
  }),
  finalCta: z.object({ title: copyString, cta: copyString }),
});

export type EventHomepageContent = z.infer<typeof eventHomepageContentSchema>;

export function readEventHomepageContent(copy: <T>(key: string) => T): EventHomepageContent {
  return eventHomepageContentSchema.parse(copy<EventHomepageContent>('event_home'));
}
